export default __webpack_public_path__ + "static/media/Background_00160.54206dd2.png";